import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const GridViewContainer = styled.div`
  .properties-card_skeleton {
    width: ${toRem(364)};
    height: ${toRem(436)};
    border-radius: ${toRem(16)};
  }
`;
